import Tabs from '@resources/js/ui/Tabs'

const extraOffersElements = document.querySelectorAll('.js-extra-offers-block')

extraOffersElements.forEach(el => {
	const tabs = new Tabs(el)
	if (tabs.items.length) tabs.openIndex(0)
})
